import React, { useState, useEffect } from 'react';
import './Home.css';

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      image: '/Images/walgeeti_1.png',
      title: 'Welcome to Oromo Gadaa-UK',
      description: 'Preserving our heritage, building our future together'
    },
    {
      image: '/Images/together.jpeg',
      title: 'Unity in Diversity',
      description: 'Connecting Oromo communities across the United Kingdom'
    },
    {
      image: '/Images/hand.jpeg',
      title: 'Cultural Heritage',
      description: 'Celebrating and preserving our rich Gadaa traditions'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="home">
      {/* Hero Section with Slider */}
      <section className="hero">
        <div className="slider-container">
          <div className="slider">
            {slides.map((slide, index) => (
              <div 
                key={index}
                className={`slide ${index === currentSlide ? 'active' : ''}`}
              >
                <img src={slide.image} alt={slide.title} />
                <div className="slide-content">
                  <h2>{slide.title}</h2>
                  <p>{slide.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="slider-nav">
            <button className="prev" onClick={prevSlide}>&#10094;</button>
            <button className="next" onClick={nextSlide}>&#10095;</button>
          </div>
          <div className="slider-dots">
            {slides.map((_, index) => (
              <span 
                key={index}
                className={`dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              ></span>
            ))}
          </div>
          <div className="slider-counter">
            {currentSlide + 1} / {slides.length}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main className="main-content">
        <div className="container">
          {/* Welcome Section */}
          <section className="welcome-section">
            <h2>Welcome to Our Community</h2>
            <p>The Oromo Gadaa-UK is a vibrant community organization dedicated to preserving and promoting the rich cultural heritage of the Oromo people living in the United Kingdom. Our community serves as a bridge between our ancestral traditions and modern life in the UK.</p>
          </section>

          {/* Features Grid */}
          <section className="features">
            <div className="feature-grid">
              <div className="feature-card">
                <h3>Cultural Preservation</h3>
                <p>We work tirelessly to preserve and pass on our Gadaa traditions, language, and cultural practices to future generations.</p>
              </div>
              <div className="feature-card">
                <h3>Community Support</h3>
                <p>Providing support and assistance to Oromo families and individuals settling and thriving in the UK.</p>
              </div>
              <div className="feature-card">
                <h3>Educational Programs</h3>
                <p>Offering language classes, cultural workshops, and educational programs for all age groups.</p>
              </div>
              <div className="feature-card">
                <h3>Social Events</h3>
                <p>Organizing festivals, celebrations, and social gatherings to strengthen community bonds.</p>
              </div>
            </div>
          </section>

          {/* Latest News */}
          <section className="news-section">
            <h2>Latest News & Updates</h2>
            <div className="news-grid">
              <article className="news-item">
                <h3>Annual Gadaa Festival 2025</h3>
                <p>Join us for our biggest celebration of the year featuring traditional music, dance, and food.</p>
                <span className="date">March 15, 2025</span>
              </article>
              <article className="news-item">
                <h3>Oromo Language Classes</h3>
                <p>New semester of Afaan Oromoo classes starting for children and adults. Register now!</p>
                <span className="date">February 28, 2025</span>
              </article>
              <article className="news-item">
                <h3>Community Meeting</h3>
                <p>Monthly community meeting to discuss upcoming events and community matters.</p>
                <span className="date">February 20, 2025</span>
              </article>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Home;
